// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAemKx6WNyNPWADqVs79C4Z7jFo8-FKY9c",
  authDomain: "e-commerce-project-59e02.firebaseapp.com",
  projectId: "e-commerce-project-59e02",
  storageBucket: "e-commerce-project-59e02.appspot.com",
  messagingSenderId: "720132365920",
  appId: "1:720132365920:web:bb326154e10fde14846d05",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

/* async function getJsonData() {
  const res = await fetch(" http://localhost:9000/products");
  const data = await res.json();
  data.forEach((product) => addDataToCollection(product));
}

async function addDataToCollection(product) {
  const docRef = await addDoc(collection(db, "products"), product);
  console.log("Document written with ID: ", docRef.id);
}

getJsonData();
 */
